define('plugin/tickets/TicketsPlugin',['require','__original__/TicketsPlugin','lib/AppRouter','pwa/plugin/tickets/controller/TicketsController'],function (require) {

    var PluginAbstract = require('__original__/TicketsPlugin');
    var AppRouter = require('lib/AppRouter');
    var TicketsController = require('pwa/plugin/tickets/controller/TicketsController');

    return PluginAbstract.extend({
        initialize: function () {
            this.initRoutes();
        },

        initRoutes: function () {
            var clientRouter = new AppRouter({
                appRoutes: {
                    'client/tickets(/type/:type)(/)': 'clientTickets',
                },
                menuItem: 'client_tickets',
                controller: new TicketsController({
                    app: this.getOption('app'),
                    clientModel: this.getOption('clientModel'),
                })
            });
        },
    });

});
